module.exports = __webpack_public_path__ + "img/group-figure3.99a02807.svg";